import { render } from "./LeagueHeader.vue?vue&type=template&id=068f6a26&scoped=true"
import script from "./LeagueHeader.vue?vue&type=script&lang=js"
export * from "./LeagueHeader.vue?vue&type=script&lang=js"

import "./LeagueHeader.vue?vue&type=style&index=0&id=068f6a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068f6a26"]])

export default __exports__